<script setup lang="ts">
  import type { CalendarCellProps } from "reka-ui";
  import type { HTMLAttributes } from "vue";
  import { reactiveOmit } from "@vueuse/core";
  import { CalendarCell } from "reka-ui";
  import { cn } from "@/lib/utils";

  const props = defineProps<CalendarCellProps & { class?: HTMLAttributes["class"] }>();

  const delegatedProps = reactiveOmit(props, "class");
</script>

<template>
  <CalendarCell
    :class="cn('relative p-0 text-center text-sm focus-within:relative focus-within:z-20 [&:has([data-selected])]:rounded-md [&:has([data-selected])]:bg-accent [&:has([data-selected][data-outside-month])]:bg-accent/50', props.class)"
    v-bind="delegatedProps">
    <slot />
  </CalendarCell>
</template>
